<app-header
  #headerRef
  *ngIf="!isLoginRoute()"
></app-header>

<!-- <lib-header
  *ngIf="!isLoginRoute()"
  [userName]="userName"
  [userEmail]="userEmail"
  [userIconUrl]="userIconUrl"
  [isDarkMode]="themeService.isDarkMode"
  [icons]="icons"
  (logout)="onLogout()"
  (openWebsite)="openWebsite($event)"
  [showSidebar]="true"
  [showUserDropdown]="true"
></lib-header> -->

<router-outlet></router-outlet>